import React, {FC} from "react";
import Divider from "../divider";
import Spacer from "../spacer";
import VidaSection from "../../../../components/@vida/vida-section";
import Link from "../../../../components/link";
import Note from "../note";

const ConnectingP3VehiclesAndPreviousUsingDice: FC = () => {
  return <div>
    <VidaSection title="" id="connecting-p3-vehicles-and-previous-using-dice">
      <Divider/>
      <h1>Connecting P3 Vehicles and Previous using DiCE</h1>

      {/* Print Service CheckList */}
      <Spacer/>
      <VidaSection title="Print Service CheckList" id="print-service-checkList">
        <div className="links">
          <Link
            href="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20P3%20Vehicles%20and%20Previous%20using%20DiCE/Print%20Service%20CheckList.pdf">
            <span className="click-icon">
              <i className="fas fa-arrow-alt-circle-right"/>
            </span>
            Print Service CheckList
          </Link>
        </div>
      </VidaSection>

      {/* Installing the USB driver for DiCE */}
      <Spacer/>
      <VidaSection title="Installing the USB driver for DiCE" id="installing-the-usb-driver-for-dice">
        <p><strong>Installing the USB driver for DiCE</strong></p>
        <p>For each new or additional DiCE unit that is going to be used in VIDA, the USB driver must be installed
          separately. This is done automatically in Windows when the DiCE unit is connected to a USB port. Carry out the
          instructions below</p>
        <Note body={<p>For some operating systems, the installation of the DiCE USB driver requires that the user has
          administrator rights for the computer that is used.</p>}/>
        <ol>
          <li>Power up the DiCE unit by connecting it to the 12 V DC adapter, see the picture below. Alternatively, use
            the Battery cable (part number 9513004) and connect it to the vehicle battery.<br/><img
              src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20P3%20Vehicles%20and%20Previous%20using%20DiCE/Installing%20the%20USB%20driver%20for%20DiCE_image1.jpg"
              alt="Installing the USB driver for DiCE_image1"/><p>Fig. 285: Attach power supply here</p><Spacer/><img
              src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20P3%20Vehicles%20and%20Previous%20using%20DiCE/Installing%20the%20USB%20driver%20for%20DiCE_image2.jpg"
              alt="Installing the USB driver for DiCE_image2"/><p>Fig. 286: Battery cable attached</p><Spacer/></li>
          <li>Remove the cover of the DiCE unit by turning the screw on the cover.<br/><img
            src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20P3%20Vehicles%20and%20Previous%20using%20DiCE/Installing%20the%20USB%20driver%20for%20DiCE_image3.jpg"
            alt="Installing the USB driver for DiCE_image3"/><p>Fig. 287: Remove the cover by turning the screw</p>
            <Spacer/></li>
          <li>Connect a short USB cable to the DiCE unit.<br/><img
            src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20P3%20Vehicles%20and%20Previous%20using%20DiCE/Installing%20the%20USB%20driver%20for%20DiCE_image4.jpg"
            alt="Installing the USB driver for DiCE_image4"/><p>Fig. 288: Input for USB</p><Spacer/></li>
          <li>Connect the USB cable to a free USB port in the computer. Detach the Bluetooth adapter cable temporarily
            if there is only one USB port in the computer.<br/>{"->"} Windows will start to install the DiCE unit when
            the USB cable is connected to the USB port. This might take several minutes. Depending on computer settings,
            this will be done either via an installation wizard or automatically in the background.
          </li>
          <li>When the installation is completed a message appears, informing that the device drivers installed
            successfully.<br/>{"->"} The DiCE is ready to use.
          </li>
        </ol>
      </VidaSection>

      {/* DiCE Firmware */}
      <Spacer/>
      <VidaSection title="DiCE Firmware" id="dice-firmware">
        <p><strong>Checking and updating the firmware in a DiCE</strong></p>
        <p>Updating the internal software (also called firmware) in a DiCE unit is done via VIDA or the DiCE Firmware
          Update application. This assumes that the USB driver has been installed for the DiCE unit, see Installing the
          USB driver for DiCE.</p>
        <p>The DiCE unit has to be connected with a USB cable and 12 V feed. Ensure that the Firmware status LED is
          flashing green.</p>
        <p>The user interface for updating software is available in English only.</p>
        <ol>
          <li><strong>Connecting DiCE</strong><br/>Connect the DiCE unit to a 12 V supply.<br/><br/><img
            src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20P3%20Vehicles%20and%20Previous%20using%20DiCE/DiCE%20Firmware_image1.jpg"
            alt="DiCE Firmware_image1"/></li>
          <br/>Fig. 289: Battery cable attached<Spacer/>
          <li><strong>Connect the DiCE unit via the USB cable to the computer, see Installing the USB driver for
            DiCE.</strong><br/><br/><img
            src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20P3%20Vehicles%20and%20Previous%20using%20DiCE/DiCE%20Firmware_image2.jpg"
            alt="DiCE Firmware_image2"/><br/>Fig. 290: USB cable attached<Spacer/></li>
          <li><strong>Choose DiCE unit in VIDA</strong><br/><p>Select the Connected Vehicles tab and choose the
            appropriate DiCE in the drop-down menu.</p><br/>{"->"} The DiCE Configuration button appears.<br/><br/><img
            src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20P3%20Vehicles%20and%20Previous%20using%20DiCE/DiCE%20Firmware_image3.jpg"
            alt="DiCE Firmware_image3"/><br/>Fig. 291: DiCE Configuration<Spacer/></li>
          <li>Click <strong>DiCE Configuration</strong>.<br/>{"->"} The DiCE Configuration pop-up opens.</li>
          <li>Click <strong>DiCE Update</strong>.<br/>{"->"} The Firmware Update window opens.<br/>The DiCE Firmware
            Update application can also be started from <strong>All Programs {"->"} DiCE {"->"} DiCE Firmware
              Update</strong> in the Start Menu in Windows.
          </li>
          <li><strong>Updating the DiCE unit software</strong><br/>Ensure that the correct DiCE unit and firmware file
            are selected in the Firmware Update window. The firmware can be found in the folder C:\Program
            Files\DiCE\Tools\DiCE_x_x_x.mot.
          </li>
          <li>Click <strong>Update</strong>.<br/>{"->"} The update is performed. It should not take more than a few
            minutes. If the DiCE unit already has the latest firmware a dialogue box opens, asking whether to load the
            firmware again or not.
          </li>
          <li>Close the Firmware Update application tool by clicking <strong>Close</strong>.</li>
          <li>If the firmware update fails, please restart the DiCE and retry.</li>
          <li>When the update is finished, the text Device update OK should be displayed.</li>
        </ol>
      </VidaSection>

      {/* Connecting DiCE for GGD and D2 Vehicle P3 or older */}
      <Spacer/>
      <VidaSection title="Connecting DiCE for GGD and D2 Vehicle P3 or older"
                   id="connecting-dice-for-ggd-and-d2-vehicle-p3-or-older">
        <p><strong>Connecting a DiCE to a vehicle</strong></p>
        <p>Carry out the following procedure in order to connect a DiCE to a vehicle.</p>
        <ol>
          <li>Ensure that the USB cable or the Bluetooth adapter is connected to the VIDA client.</li>
          <li>Always ensure that the vehicle is connected to a battery charger before the DiCE is connected to the
            vehicle. DiCE is powered by the vehicle, not via USB.
          </li>
          <li>Connect the DiCE to the diagnostic socket in the vehicle.</li>
          <li>Hang the DiCE unit so that it is visible.</li>
          <li>Put the ignition to position II.</li>
          <li>Start VIDA.</li>
          <li>Open the <strong>Home</strong> {"->"} <strong>Connected Vehicles</strong> tab.<br/>{"->"} All DiCE units
            that are installed on the VIDA workstation are listed in the drop-down menu. If you only have one DiCE
            installed on the VIDA workstation, this DiCE is selected in the drop-down menu by default.
          </li>
          <li>Ensure that the correct DiCE is chosen in the drop-down menu.</li>
          <li>Click <strong>Read Vehicle</strong> to read the VIN from the vehicle.</li>
          <li>Click <strong>Connect</strong> to connect the DiCE to the vehicle.</li>
        </ol>
      </VidaSection>
    </VidaSection>
    <style jsx>{`
      .links {
        margin-top: 15px;
        display: grid;
        align-items: center;
      }

      .links > :global(a) {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        text-decoration: none;
        color: #333;
        padding: 1rem;
        margin-bottom: 0.5rem;
        cursor: pointer;
      }

      .links > :global(a:hover) {
        background-color: #eee;
      }

      .click-icon {
        float: left;
        padding-right: 2rem;
      }

      img {
        width: 100%;
      }
    `}</style>
  </div>
}

export default ConnectingP3VehiclesAndPreviousUsingDice;
